import { Box, Divider, Typography } from "@mui/material";
import { CurrentSubscription } from "../../store/auth-slice/auth-slice";
import { useTranslation } from "react-i18next";

interface SubscriptionDetailsProps {
  subscription: CurrentSubscription | null;
}

function SubscriptionDetails({ subscription }: SubscriptionDetailsProps) {
    const { t } = useTranslation();

    if (!subscription) {
        return null;
    }

    return (
        <Box sx={{ px: 2, pb: 1.5, pt: 0.5, maxWidth: 340 }}>
            <Typography
                variant="subtitle1"
                sx={{
                    color: 'text.primary',
                    fontWeight: 600,
                    typography: { xs: 'body2', sm: 'subtitle1' },
                }}
            >
                {t('CURRENT_SUBSCRIPTION_TITLE', { name: t(subscription.name, { defaultValue: subscription.name }) })}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                {subscription.items?.map((item) => (
                    <Box
                        key={item.name}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            gap: 1,
                            flexWrap: 'wrap',
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: 'text.secondary', typography: { xs: 'body2', sm: 'body2' } }}
                        >
                            {t(item.name, { defaultValue: item.name })}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.primary',
                                fontWeight: 600,
                                textAlign: 'right',
                                wordBreak: 'break-word',
                            }}
                        >
                            {item.value ?? '-'}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default SubscriptionDetails;
